import { MachineData } from "../../../services/dto/machine";

  export const mockData: MachineData[] = [
    {
      code: "001",
      name: "Machine 001",
      type:"Washer",
      outlet:"Outlet 001"
    },
    {
      code: "002",
      name: "Machine 002",
      type:"Dryer",
      outlet:"Outlet 002"
    },
  ];
  
